import React from "react";
import { Field } from "react-final-form";

export const RadioField = ( props ) => {
    const { fieldId, fieldLabel, fieldValue, children } = props;
    const radioId = fieldId.split( " " ).join( "" )
    return <div className="radio">
        <label htmlFor={ radioId + "_" + fieldValue }>
            <Field
                id={ radioId + "_" + fieldValue }
                component="input"
                type="radio"
                name={ fieldId }
                value={ fieldValue }
                required={ true }
            />{ ' ' }
            { fieldLabel }&nbsp;
            {
                children &&
                <span>{ children }</span>
            }
        </label>
    </div>
}